import React from "react";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import { format } from "date-fns";
import { Card, CardContent, CardHeader, CardTitle } from "components/ui/card";
import { Button } from "components/ui/button";

const RowCard = ({ row }) => {
  const navigate = useNavigate();
  // console.log(row)
  return (
    <Card key={row?.id}>
      <CardHeader>
        <CardTitle className="text-lg">
          {row?.first_name} {row?.last_name}
        </CardTitle>
        <div className="text-sm text-muted-foreground">
          {row?.email} {row?.mobiie}
        </div>
      </CardHeader>
      <CardContent>
        <div className="mb-4 grid grid-cols-1 gap-3 text-sm sm:grid-cols-2">
          <div className="flex gap-2">
            <span className="font-semibold">ID:</span>
            <span>#{row?.id}</span>
          </div>
          <div className="flex gap-2">
            <span className="font-semibold">Organization:</span>
            <span>#{row?.organization} - {row?.organization_name}</span>
          </div>
          <div className="flex gap-2">
            <span className="font-semibold">Name:</span>
            <span>{row?.name}</span>
          </div>
          <div className="flex gap-2">
            <span className="font-semibold">Created:</span>
            <span>{row?.created_at ? format(new Date(row?.created_at), "dd-MMM-yyyy") : "-"}</span>
          </div>
          <div className="flex gap-2">
            <span className="font-semibold">Last Updated:</span>
            <span>{row?.updated_at ? format(new Date(row?.updated_at), "dd-MMM-yyyy") : "-"}</span>
          </div>
        </div>
        <div className="flex justify-end">
          <Button onClick={() => navigate(`/app/categories/details/${row?.id}`)}>
            View More or Edit Details
          </Button>
        </div>
      </CardContent>
    </Card>
  );
};

RowCard.propTypes = {
  row: PropTypes.object.isRequired,
};

export default RowCard;
